import { Box, Button, Stack, Typography, styled } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Layout } from "../dashboard/dashboard";
import DataTable from "./SaleTable";
import { Back } from "../../assets/Svg";
import PrintIcon from "@mui/icons-material/Print";
import ReactToPrint from "react-to-print";

import { getBills, getClient, getDuePaymentsBills } from "../../apiservices";
import BillPreview from "./BillPreview";
import { formatDate } from "../general";

const Btn = styled(Button)({
  minWidth: "126px",
  height: "36px",
  padding: "4px",
  borderRadius: "4px",
  textTransform: "none",
  background: "#FFFFFF",
  color: "#05ae97",
  marginRight: 10,
  "&:hover": {
    background: "#F6F6F6",
  },
  "&:active": {
    background: "#FFFFFF",
  },
});
const DuePaymentsBills = () => {
  const ViewBillRef = useRef();
  const [state, setState] = useState({
    addItem: false,
    viewBill: false,
    tableArr: [],
    viewBillModal: false,
    billData: {},
    rowData: [],
    salesData: {},
    billsLength: 0,
    viewBillData: {},
    itemsArr: [],
    searchData: [],
    customData: {},
    clientData: [],
    clientBalance: 0,
    startDate: formatDate(new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)),
    endDate: formatDate(new Date()),
    arr: [],
  });
  const addSales = (data = "") => {
    setState((prev) => ({
      ...prev,
      addItem: !prev.addItem,
    }));
    if (data.id) {
      setState((prev) => ({
        ...prev,
        itemsArr: data.saveSale
          ? [...data?.items, ...data?.saveSale]
          : data?.items,
        customData: data,
        arr: data.items,
      }));
    }
  };
  const viewBills = async (data = "") => {
    getClientsData();
    setState((prev) => ({
      ...prev,
      viewBill: !prev.viewBill,
    }));
    if (data) {
      let obj = {};
      let res = await getClient(obj);
      if (res.success) {
        let filtered = res.data.filter(
          (item) => item.client_name === data.client
        );
        setState((prev) => ({
          ...prev,
          clientBalance: filtered[0]?.opening_balance,
          viewBillData: data,
          // tableArr: data.saveSale
          //   ? [...data?.items, ...data?.saveSale]
          //   : data?.items,
        }));
      }
    }
  };
  const getData = (data) => {
    setState((prev) => ({ ...prev, tableArr: data }));
  };
  const viewBillModal = (data = "") => {
    setState((prev) => ({
      ...prev,
      viewBillModal: !prev.viewBillModal,
      billData: data,
      viewBillData: data,
    }));
  };
  const getClientsData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    let obj = {

    };
    let res = await getClient(obj);
    if (res.success) {
      setState((prev) => ({ ...prev, clientData: res.data }));
    }
  };
  const getBillData = async () => {
    let userData = JSON.parse(localStorage.getItem("user"));
    let res = await getDuePaymentsBills(state.startDate, state.endDate);
    if (res.success) {
      res.data.map((x) => {
        x.discounted_amount = (x.amount - x.invoice_discount_amount)
        x.paid_amount = (parseFloat(x.inv_paid_amount) + parseFloat(x.paid_amount))
        x.remaining_amount = (x.discounted_amount - x.paid_amount)
        if (x.voucher_no.length == 1) {
          x.show_voucher_no = `Invoice#00${x.voucher_no}`
        }
        else if (x.voucher_no.length == 2) {
          x.show_voucher_no = `Invoice#0${x.voucher_no}`
        }
        else {
          x.show_voucher_no = `Invoice#${x.voucher_no}`
        }
      })
      setState((prev) => ({
        ...prev,
        rowData: res.data,
      }))
    }
    else {
      setState((prev) => ({
        ...prev,
        rowData: [],
      }))
    }
  };

  useEffect(() => {
    getBillData();
    getClientsData();
  }, [state.startDate, state.endDate]);

  const handleChange = (e) => {
    let { value } = e.target;
    let { name } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Stack sx={{ paddingLeft: 2, paddingRight: 2 }}>
      {(
        <>
          <Layout
            justifyContent="center"
            alignItems={"center"}
            direction={"row"}>
            <Typography
              sx={{
                color: "#000",
                fontSize: "24px",
                fontWeight: 700,
              }}></Typography>
            <Typography
              sx={{ color: "#000", fontSize: "24px", fontWeight: 700 }}>
              Due Payments Bills
            </Typography>
          </Layout>
          <Stack
            direction={"row"}
            sx={{ padding: "10px" }}
            justifyContent={"start"}
            alignItems={"center"}
            spacing={2}>
            <Stack
              sx={{
                width: "25%",
                background: "#F6F6F6",
                borderRadius: "10px",
                boxShadow: "rgb(77, 175, 81) 0px 2px 5px",
                padding: 1,
              }}>
              <label>Due Date From</label>
              <input
                style={{ padding: "10px", borderRadius: "6px" }}
                type="date"
                value={state.startDate}
                name="startDate"
                onChange={handleChange}
              />
            </Stack>
            {/* <Typography sx={{ fontSize: "18px" }}>To</Typography> */}
            <Stack
              sx={{
                width: "25%",
                background: "#F6F6F6",
                borderRadius: "10px",
                boxShadow: "rgb(77, 175, 81) 0px 2px 5px",
                padding: 1,
              }}>
              <label>Due Date To</label>
              <input
                style={{ padding: "10px", borderRadius: "6px" }}
                type="date"
                value={state.endDate}
                name="endDate"
                onChange={handleChange}
              />
            </Stack>
          </Stack>
          <Stack sx={{ padding: "20px" }}>
            <DataTable
              addSales={addSales}
              view={(data) => viewBills(data)}
              rowData={state.rowData !== undefined && state.rowData}
              getBillData={getBillData}
              clientData={state.clientData}
            />
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default DuePaymentsBills;
